import React from 'react'
import './About.css'
import ME from '../../assets/fr2.jpg'
import { FaAward } from 'react-icons/fa'
import { FiUsers } from 'react-icons/fi'
import { GrProjects } from 'react-icons/gr'
const About = () => {
  return (
    <section id="about">
      <h5>Know More</h5>
      <h2>About Me</h2>

      <div className="container about__container">
        <div className="about__me">
            <div className="about__me-image">
              <img src={ME} alt=""/>
            </div>
        </div>

        <div className="about__content">
          <div className="about__cards">
            <article className="about__card">
              <FaAward className='about__icon'/>
              <h5>Experience</h5>
              <small>3+ Year Working Experience</small>
            </article>
            <article className='about__card'>
              <FiUsers className='about__icon' />
              <h5>Clients</h5>
              <small>100+ Clients</small>
            </article>
            <article className='about__card'>
              <GrProjects className='about__icon' />
              <h5>Projects</h5>
              <small>80+ completed projects</small>
            </article>
          </div>
          <p>
            Gibsons is a passionate full-stack developer with extensive expertise in web and Android development. With a deep understanding of languages and technologies like JavaScript, Python, Golang, and Kotlin, Gibsons possesses a broad range of technical knowledge. Furthermore, Gibsons is proficient in popular frameworks and libraries such as ReactJS, Angular, and Node.js. Additionally, Gibsons has experience working with machine learning platforms in Python, including NumPy and Pandas. Constantly seeking new challenges and opportunities, Gibsons strives to create innovative and impactful solutions in the world of software development.
          </p>
          <a href="mailto:gibsonsgibson88@gmail.com" className='btn btn-primary'>Contact Me</a>
        </div>
      </div>
    </section>
  )
}

export default About
